<template>
  <f7-page login-screen>
    <navbarlist :list="'groups'"></navbarlist>

    <loader v-if="loader"></loader>

    <div v-else>
          <f7-block class="text-center text-uppercase">
            <h4>{{ 'club.new_group' | translate }}</h4>
          </f7-block>
          <f7-list form no-hairlines-md @submit.prevent="createGroup">
            <f7-list-input
              :label="'club.name' | translate"
              type="text"
              :placeholder="'club.name' | translate"
              :value="group.name"
              @input="group.name = $event.target.value"
              required
              validate
              :error-message="'global.required' | translate"
              clear-button
            >
            </f7-list-input>
            <f7-list-item :title="'club.color_group' | translate" class="custom-select">
              <select name="color" v-model="group.color">
                <option v-for="(color, index) in paleteColorsDot" :key="index" :value="index" :selected="index == group.color">
                    {{color.label}}
                </option>
              </select>
            </f7-list-item>
             <f7-list-input
              :label="'club.premium_amount' | translate"
              type="number"
              :placeholder="'club.premium_amount' | translate"
              :value="group.due_price"
              @input="group.due_price = $event.target.value"
              required
              validate
              :error-message="'global.required' | translate"
              clear-button
            >
            </f7-list-input>
            <f7-list-input
              :label="'club.description' | translate"
              type="textarea"
              :placeholder="'club.description' | translate"
              :value="group.description"
              @input="group.description = $event.target.value"
              clear-button
            >
            </f7-list-input>
            <f7-block class="text-center">
              <f7-button v-if="!loaderGroup" type="submit" raised>
                  {{ 'club.create_new_group' | translate }}
              </f7-button>
              <f7-button v-else raised>
                <f7-preloader :size="20" color="white"></f7-preloader>
              </f7-button>
            </f7-block>
          </f7-list>
    </div>

  </f7-page>
</template>

<script>
import Navbarlist from "@/components/Navbar/Navbarlist.vue";
import Loader from "@/components/Loader";
import groupsServices from "@/services/GroupsServices.js"
import CONSTANTS from "@/utils/constants.js"
import mixinUser from "@/mixins/mixinUser"

export default {
  mixins: [mixinUser],
  components: {
    Navbarlist,
    Loader,
  },
  data: () => {
    return {
      loader: false,
      loaderGroup: false,
      paleteColorsDot: CONSTANTS.COLORS_DOT,
      group: {
        name: '',
        color: '0',
        description: '',
      },
    };
  },
  mounted() {
    if (this.isAuthenticated) {
      this.fetchDataUser()
    }
  },
  methods: {
    async createGroup() {
      try {
        this.loaderGroup = true;

        const responseCreateGroup = await groupsServices.createGroup(this.group);
          if (responseCreateGroup.data.id) {
            this.$f7router.navigate(`/groups/`)
          }
      } catch (error) {
        this.$f7.toast
          .create({
            text: "Something went wrong with the outline creation. Please try again or contact your administrator.",
                        position: "bottom",
            
            closeTimeout: 3000
          })
          .open();
        console.log(error);
      }
      this.loaderGroup = false;
    },
  }
};
</script>

<style lang="scss">
</style>